<template>
  <!-- 商品管理 -->
  <div class="el-card pd20">
    <div class="main">
      <div class="box">
        <!--  -->
        <div class="search">
          <div class="search-gropu">
            订单类型
            <el-select class="search-child" @change="courseNameHandle" v-model="type" placeholder="请选择订单类型" clearable>
              <el-option v-for="(item,index) in type_list" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
            </el-select>
          </div>
          <!--  -->
          <div class="search-gropu">
            订单状态
            <el-select class="search-child" @visible-change="courseHandle" v-model="status" placeholder="请选择订单状态" clearable>
              <el-option v-for="(item,index) in status_list" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
            </el-select>
          </div>
          <!--  -->
          <div class="search-gropu on">
            下单时间
            <el-date-picker class="buy-time" v-model="buy_time" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </div>
        <!--  -->
        <div class="search search-btn">
          <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
          <el-button type="primary" @click="exportExcelHandle" size="medium">导出数据</el-button>
        </div>
      </div>
      <!-- list-->
      <div class="el-card pd20">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="order_num" label="订单号"></el-table-column>
          <el-table-column prop="create_time" label="下单时间"> </el-table-column>
          <el-table-column prop="product" label="商品名称"></el-table-column>
          <el-table-column label="订单类型">
            <template slot-scope="scope">
              {{scope.row.type==1?'普通订单':'套餐订单'}}
            </template>
          </el-table-column>
          <el-table-column label="订单状态">
            <template slot-scope="scope">
              {{scope.row.status==1?'已付款':scope.row.status==2?'待付款':'失效'}}
            </template>
          </el-table-column>
          <el-table-column prop="num" label="购买数量"></el-table-column>
          <el-table-column prop="pay_price" label="实付金额（元）"></el-table-column>
          <el-table-column label="买家头像/昵称">
            <template slot-scope="scope">
              <div class="userinfo">
                <img :src="scope.row.headimgurl" alt="">
                <div>{{scope.row.nickname}}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加按钮 -->
      <!-- <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="addGraph" circle></el-button> -->
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
      </el-pagination>
      <!-- -->
      <!-- <div class="pages-box"></div>  -->
    </div>
  </div>
</template>
<script>
import {
  orderList,
  orderExport
} from "@/api/measurement";
import {
  exportExcel
} from "@u/tools";
export default {
  data() {
      return {
        list: [],
        pages: {},
        // 下单时间
        buy_time: [],
        nickname: '',
        type: 0,
        status: 0,
        obj: {},
        type_list: [{
          id: 0,
          name: '全部'
        }, {
          id: 1,
          name: '普通订单'
        }, {
          id: 2,
          name: '套餐订单'
        }],
        status_list: [{
          id: 0,
          name: '全部'
        }, {
          id: 1,
          name: '已支付'
        }, {
          id: 2,
          name: '待付款'
        }]
      }
    },
    methods: {
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      //导出的方法
      exportExcelHandle() {
        let h = [
          '订单号',
          '下单时间',
          '商品名称',
          '订单类型',
          '订单状态',
          '购买数量',
          '实付金额',
          '买家昵称'
        ];
        let b = [
          'order_num',
          'create_time',
          'product',
          'type',
          'status',
          'num',
          'pay_price',
          'nickname'
        ];

        orderExport(this.obj).then((res) => {
          let list = res.list; //把data里的tableData存到list
          for (let i = 0; i < list.length; i++) {
            list[i].order_num = list[i].order_num += '`';
            if(list[i].type ==1){
                list[i].type = '普通订单';
            }else {
                list[i].type = '套餐订单';
            }
            if(list[i].status ==1){
                list[i].status = '已付款';
            }else if(list[i].status ==2) {
                list[i].status = '待付款';
            }else {
                list[i].status = '失效';
            }
          }

          exportExcel(h, b, list, '测评订单看板')
        })

      },
      // 根据选择的课程名称修改期次
      courseNameHandle() {
        for (let key in this.course_name_list) {
          if (this.course_name == this.course_name_list[key].id) {
            this.course_list = this.course_name_list[key].course;
            return
          }
        }

      },
      pullData() {
        this.$showLoading();
        this.obj = {
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25 //每页数量，默认25
        };
        // 判断如果有值为真的情况下传参,否则不传
        if (this.type) {
          this.obj['type'] = this.type;
        }
        if (this.status) {
          this.obj['status'] = this.status;
        }
        if (this.buy_time && this.buy_time.length > 0) {
          this.obj['begin'] = this.buy_time[0]; //开始时间
          this.obj['end'] = this.buy_time[1]; //结束时间
        }
        orderList(this.obj).then((data) => {
          this.list = data.list;
          this.pages = data.pager;
          // 课程名称
          this.course_name_list = data.course;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.main {
  position: relative;
}

.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.pages-box {
  height: 32px;
  margin-top: 30px;
}

.preview {
  width: 300px;
  border-radius: 5px;
}

.box {
  margin-bottom: 20px;
}

.search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}

.search-gropu.on {
  flex: 1.5;
}

.search-child {
  margin-left: 20px;
  width: 200px;
}

.userinfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
</style>
<style lang="scss">
.buy-time {
  input {
    background-color: transparent !important;
    width: 60% !important;
  }
}

.buy-time.el-date-editor.el-input,
.buy-time.el-date-editor.el-input__inner {
  margin-left: 20px;
}
</style>
